import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_scheduled_api_file_configuration_card = _resolveComponent("scheduled-api-file-configuration-card")!
  const _component_new_api_file_configuration_modal = _resolveComponent("new-api-file-configuration-modal")!
  const _component_base_confirmation_modal = _resolveComponent("base-confirmation-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { class: "d-flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "ml-auto mr-1",
          type: "primary",
          disabled: !$setup.userCanWriteEngagementGainImportConfiguration || $setup.isSignedOff,
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showNewConfigurationModal = true))
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('add')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: !$setup.userCanWriteEngagementGainImportConfiguration || $setup.isSignedOff,
          onClick: $setup.recalculateApiNextRuns
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('recalculateNextRuns')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scheduledGainApiFileConfigurations, (item, index) => {
      return (_openBlock(), _createBlock(_component_el_row, {
        key: index,
        class: "mt-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_scheduled_api_file_configuration_card, {
            configuration: item,
            "configuration-history": $setup.gainApiFileConfigurationHistory ?? [],
            "disable-delete-and-save": 
        !$setup.userCanWriteEngagementGainImportConfiguration || $setup.isSignedOff
      ,
            "api-connections": $setup.gainApiConnectionConfigurations,
            "gain-import-configuration": $setup.gainImportConfiguration,
            "exiting-output-file-names": $setup.existingFileNames(index),
            "next-run-timestamp": $setup.getNextRunTimestamp(item.outputFileName),
            onUpdate: (configuration) => $setup.updateEntry(index, configuration),
            onDelete: ($event: any) => ($setup.deleteEntry(index)),
            onSave: ($event: any) => ($setup.saveEntry(index)),
            onFetchHistory: ($event: any) => ($setup.fetchApiFileConfigurationHistory(item.configurationName!))
          }, null, 8, ["configuration", "configuration-history", "disable-delete-and-save", "api-connections", "gain-import-configuration", "exiting-output-file-names", "next-run-timestamp", "onUpdate", "onDelete", "onSave", "onFetchHistory"])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_component_new_api_file_configuration_modal, {
      "model-value": $setup.showNewConfigurationModal,
      "existing-names": 
      $setup.allGainApiFileConfigurations.map(el => el.configurationName ?? '')
    ,
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showNewConfigurationModal = false)),
      onConfirm: $setup.handleConfigurationCreate
    }, null, 8, ["model-value", "existing-names", "onConfirm"]),
    _createVNode(_component_base_confirmation_modal, {
      modelValue: $setup.showDeleteConfigurationModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showDeleteConfigurationModal) = $event)),
      "feedback-text": _ctx.$t('configurationDeleted'),
      onConfirm: $setup.deleteConfiguration,
      onClose: _cache[3] || (_cache[3] = ($event: any) => {
      {
        $setup.configurationNameToBeDeleted = null;
        $setup.showDeleteConfigurationModal = false;
      }
    })
    }, {
      content: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('confirmDeleteConfiguration')), 1),
        _createElementVNode("p", _hoisted_1, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('confirmDeleteConfigurationNote')), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "feedback-text", "onConfirm"])
  ], 64))
}